import React from 'react';

export default function MetricCard({ title, value, subtitle, isLoading }) {
  return (
    <div className="bg-white dark:bg-gray-900 overflow-hidden shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <dt className="text-sm font-medium text-gray-500 dark:text-gray-400 truncate">{title}</dt>
        <dd className="mt-1 text-3xl font-semibold text-gray-900 dark:text-gray-100">
          {isLoading ? (
            <div className="h-8 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
          ) : (
            value ?? 'N/A' // Handle null or undefined values
          )}
        </dd>
        {subtitle && !isLoading && (
          <dd className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            {subtitle}
          </dd>
        )}
      </div>
    </div>
  );
} 